<template>
  <div class="wrap-document">
    <div class="page" v-for="(platform, i) in dataPrint.platform" :key="i">
      <p class="title">
        SURAT PERNYATAAN TELAH BERPENGALAMAN MELAKSANAKAN TRANSAKSI PERDAGANGAN BERJANGKA KOMODITI
        <span v-if="platform.name">{{ "(" + platform.name + ")" }}</span>
        <span v-else>
          <span v-show="platform.platform == 'BEI05001'">( Jafets Now )</span>
          <span v-show="platform.platform == 'BEI05002'">( Meta Trader 5 )</span>
        </span>
      </p>
      <div class="content">
        <p>Yang mengisi formulir di bawah ini :</p>
        <tr>
          <td><label>Nama Lengkap</label></td>
          <td>:</td>
          <td class="format-text">
            {{ dataPrint.fullname ? dataPrint.fullname : "............................." }}
          </td>
        </tr>
        <tr>
          <td><label>Tempat/Tanggal Lahir</label></td>
          <td>:</td>
          <td class="format-text">
            {{ dataPrint.tempat_lahir ? dataPrint.tempat_lahir : "............................." }},
            {{ dataPrint.tanggalLahir ? dataPrint.tanggalLahir : "............................." }}
          </td>
        </tr>
        <tr>
          <td><label>Alamat Rumah</label></td>
          <td>:</td>
          <td class="format-text">
            {{ dataPrint.alamat ? dataPrint.alamat : "............................." }}
          </td>
        </tr>
        <tr>
          <td><label>No Identitas (KTP/SIM/Paspor)</label></td>
          <td>:</td>
          <td class="format-text">
            {{ dataPrint.ktp ? dataPrint.ktp : "............................." }}
          </td>
        </tr>
        <tr>
          <td>
            <label>
              No. Demo Acc
              <!-- <span v-if="platform.name">{{ platform.name }}</span>
              <span v-else>
                <span v-show="platform.platform == 'BEI05001'">Jafets Now</span>
                <span v-show="platform.platform == 'BEI05002'">GOFX</span>
              </span> -->
            </label>
          </td>
          <td>:</td>
          <td class="format-text">
            {{ platform.demo_username ? platform.demo_username : platform.username }}
          </td>
        </tr>
      </div>

      <div class="content">
        Dengan mengisi kolom “YA” dibawah ini, saya menyatakan bahwa saya telah memiliki pengalaman yang mencukupi dalam melaksanakan transaksi Perdagangan Berjangka
        karena pernah bertransaksi pada Perusahaan Pialang Berjangka Komoditi pada {{ dataPrint.nama_pialang ? dataPrint.nama_pialang : "" }} dan telah memahami
        tentang tata cara bertransaksi Perdagangan Berjangka Komoditi.
        <form>
          <div class="form-group"></div>
        </form>
      </div>
      <div class="content">
        Demikian Pernyataan ini dibuat dengan sebenarnya dalam keadaan sadar, sehat jasmani dan rohani serta tanpa paksaan apapun dari pihak manapun.
        <form>
          <div class="form-group"></div>
        </form>
      </div>

      <div class="persetujuan">
        <div class="ttd">
          <p>Pernyataan menerima</p>
          <div class="pernyataan">
            <input type="radio" v-model="statement" name="confirmProfil" :value="true" required @change="handleValue" />
            <label>Ya</label>

            <input type="radio" v-model="statement" :value="false" @change="handleValue" />
            <label>Tidak</label>
          </div>
        </div>
        <div class="ttd">
          <p>Menerima pada Tanggal</p>
          <div>
            {{ currentDate | formatDateTime }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullName: String,
    dataPrint: Object,
    statement: Boolean,
  },
  data() {
    return {
      currentDate: "",
      statementInput: "",
    };
  },
  mounted() {
    this.currentDate = new Date();
    this.statementInput = this.statement;
  },
  methods: {
    handleValue(e) {
      this.$emit("changeValue", e.target._value);
    },
  },
};
</script>

<style scoped>
label {
  width: 8rem;
}
.page {
  padding: 1cm;
  height: 257mm;
}

.format-text {
  text-transform: capitalize;
  padding: 0px 0.5rem;
}

.format-text::first-letter,
.format-text::first-line {
  text-transform: capitalize;
}

.wrap-document {
  min-height: 295mm;
  padding: 10mm;
  border-radius: 5px;
  background: white;
  position: relative;
}

.tanda-tangan {
  width: 80%;
  text-align: center;
}

.top {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 25px;
}

.nomor {
  font-weight: bold;
}

.lampiran p {
  margin: 0;
  text-align: right;
}

.title {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  margin-bottom: 2rem;
}

.content {
  font-size: 12px;
  text-align: justify;
}

.sub-content {
  font-weight: 700;
}

form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
}

label {
  margin-right: 15px;
}

.persetujuan {
  /* width: 60%; */
  font-size: 12px;
  margin: 30px 0 90px;
}

.persetujuan .ttd {
  display: flex;
  gap: 1rem;
}

.persetujuan .ttd p {
  width: 10rem;
}

.pernyataan input {
  margin-right: 0.6rem;
}

.pernyataan label {
  width: 2rem;
}

@page {
  size: A4;
  margin: 0;
}

@media (max-width: 768px) {
  .wrap-document {
    width: 100%;
    padding: 30px 0;
  }

  .title {
    margin: 20px auto !important;
  }

  .page {
    padding: 0;
  }
}
</style>
